<template>    
    <mainlist
        color="#fff"
        :items="companies"
        :list="list"
    ></mainlist>
</template>
<script>
    import { mapGetters } from 'vuex';    
    import mainlist from '../components/lists/MainList.vue'; 
    export default {   
    
    props: [
        
    ],
    components:{
        mainlist: mainlist
    },
    data() {
        return {  
           list:"companies"
                    
        }
    },
    computed: {
        ...mapGetters({            
            companies: 'companies/companies'
        }),
        
    },
    methods: {
        
    },
    mounted() {
        this.$store.dispatch('companies/getAll')
        this.$store.dispatch('adresses/getAll')
    }
    
    
}
</script>